import { MarginDetails } from '../types'
import {
  GET_MARGIN_DETAILS,
  GET_MARGIN_DETAILS_FAILURE,
  GET_MARGIN_DETAILS_SUCCESS,
} from '../actions'

interface MarginDetailsReducer {
  loadingMarginDetails: boolean
  marginDetails?: MarginDetails
  errorMessage?: string
}

const INITIAL_STATE: MarginDetailsReducer = {
  loadingMarginDetails: true,
}

export const marginDetailsReducer = (
  state: MarginDetailsReducer = INITIAL_STATE,
  action: { type: string; marginDetails: MarginDetails; errorMessage?: string }
): MarginDetailsReducer => {
  const { type, marginDetails, errorMessage } = action
  switch (type) {
    case GET_MARGIN_DETAILS:
      return { ...INITIAL_STATE, loadingMarginDetails: true }
    case GET_MARGIN_DETAILS_SUCCESS:
      return { ...state, loadingMarginDetails: false, marginDetails }
    case GET_MARGIN_DETAILS_FAILURE:
      return { ...state, loadingMarginDetails: false, errorMessage }
    default:
      return state
  }
}
